import React from 'react';
import { useNavigate } from 'react-router-dom'; // ✅ Import this
import {CancelIcon} from '../../../lib/myIcons';

function CancelButton() {
  const navigate = useNavigate(); // ✅ Hook to get navigate function

  const handleCancel = () => {
    navigate(-1); // Go back
  };

  return (
    <button type="button" className="cancel-button" onClick={handleCancel}>
      <CancelIcon color="white" />
      Cancel
    </button>
  );
}

export default CancelButton;
